import {getNativeNodeByNativeIdPath} from '../getNativeNodeByNativeIdPath';

export const getMeasurableNativeNodeByNativeIdPath = (
  nativeIdPath: string[]
): HTMLElement | null => {
  const nativeNode = getNativeNodeByNativeIdPath(nativeIdPath);
  if (!nativeNode) {
    return null;
  }

  const maybeShadowRoot = nativeNode.shadowRoot;

  // If the node is a code island, find the shadow root element
  // We expect the shadow root element to have a `data-shadow-wf-id` attribute
  // that matches the native id path
  if (maybeShadowRoot) {
    const queryString = `[data-shadow-wf-id='${JSON.stringify(nativeIdPath)}']`;
    const shadowNode = maybeShadowRoot.querySelector(queryString);
    return shadowNode as HTMLElement;
  }

  // Always fallback to the host element
  return nativeNode;
};
